module.exports = __webpack_public_path__ + "img/box61.c12c2be3.png";